

global.modules.set({
  is_booted: false,
  async init() {
    if(this.is_booted) {
      return;
    }
    this.is_booted = true;
    let openModal = [...document.querySelectorAll('.modal__open')];

    if (openModal.length) {
      openModal.forEach(item => {
        item.addEventListener('click', () => {
          document.querySelector(`[data-modal="${item.dataset.modalblock}"]`).classList.add('active');
          $('body').addClass('lock');
        })
      });
    }

    let exitModal = [...document.querySelectorAll('.modal__exit')];
    if (exitModal.length) {
      exitModal.forEach(item => {
        item.addEventListener('click', () => {
          const modal =  document.querySelector(`[data-modal="${item.dataset.exitmodal}"]`)
          if(modal) { 
            modal.classList.remove('active');
          }
          $('body').removeClass('lock');
        })
      });
    }
  }
})